import React, { useEffect, useRef } from 'react';
function Footer() {
  const annoCorrente = new Date().getFullYear();
  
  return (
    <div className="footer_part" style={{paddingTop: "3vh"}}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <div className="footer_iner text-center">
              <p style={{fontSize: '0.75rem'}}>{' '}{annoCorrente === 2024 ? annoCorrente : `2024 - ${annoCorrente}`} ilNecrologio.info. Tutti i diritti riservati - Servizio promosso da <a href="https://stefanomagnini.com/"rel="noreferrer" target="_blank" style={{color: '#ec7c09', fontWeight: '500'}}>Magnini creative solutions</a> - Designed & Developed by <a href="https://stefanocoggiola.com/"
              rel="noreferrer" target="_blank" style={{color: '#ec7c09', fontWeight: '500'}}>Stefano Coggiola</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;